import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router";

import axios from "axios";
import { getParameterByName } from "./getParamaterByName";

// @material-ui/core components
import { Checkbox, CircularProgress, FormControlLabel, InputAdornment, Link } from "@mui/material";
import { ArrowBack, ArrowForward, Lock } from "@mui/icons-material";

// Core components
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import CustomInput from "../../components/CustomInput/CustomInput";
import Button from "../../components/CustomButtons/Button";
import Danger from "../../components/Typography/Danger";

//images
import logo from "../../assets/img/logo.png";

//Style
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";

import Glas from "../../components/Loading/Glas";
import InfoBlock from "../../components/InfoBlock/InfoBlock";
import Box from "@mui/material/Box";
import { blackColor, hexToRgb } from "../../assets/jss/material-dashboard-pro-react";

const Setup2FA = () => {
  const formRef = useRef();
  const navigate = useNavigate();

  const [state, setState] = useState({
    hasErrors: false,
    errors: [],
    redirect: false,
    loading: false,
    trust: false,
    setup: null,
    qrCode: "",
    secret: "",
    email: "",
    recovery: [],
    recoveryToggle: false,
    setupShowVerify: false,
    renew: false,
    strict: false,
  });

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      renew: window.location.pathname.endsWith("renew"),
    }));

    axios
      .get("/core/2fa/setup")
      .then((result) => {
        if (!result.data.setup) {
          setState((prevState) => ({
            ...prevState,
            setup: false,
            email: result.data.email,
            strict: result.data.strict,
          }));
        } else {
          setState((prevState) => ({
            ...prevState,
            setup: true,
            email: result.data.email,
            strict: result.data.strict,
            qrCode: result.data.qr_code,
            secret: result.data.secret,
            recovery: result.data.recovery.map((item) => <li key={item}>{item}</li>),
          }));
        }
      })
      .catch((error) => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          hasErrors: true,
          errors: error.response.data.errors,
        }));
      });
  }, []);

  const handleCheckbox = (e) => {
    setState((prevState) => ({ ...prevState, trust: e.target.checked }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setState((prevState) => ({ ...prevState, loading: true }));

    let data = new FormData(formRef.current);

    if (state.renew) {
      data.append("renew", state.renew);
    }

    axios
      .post("/core/2fa/verify", data)
      .then((result) => {
        if (result.data.valid) {
          if (result.data.url) {
            window.location.href = result.data.url;
          } else {
            navigate("/manager");
          }
        } else {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            hasErrors: true,
            errors: {},
          }));
        }
      })
      .catch((error) => {
        if (error.response !== undefined) {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            hasErrors: true,
            errors: error.response.data.errors,
          }));
        } else {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            hasErrors: true,
            errors: {},
          }));
        }
      });
  };

  const logoutUser = () => {
    let data = [];
    const _token = document.head.querySelector('meta[name="csrf-token"]').content;
    data.push("_token", _token);

    axios.post("/logout", data).then((result) => {
      window.location.href = "/manager/login";
    });
  };

  const toggleRecovery = (e) => {
    e.preventDefault();
    setState((prevState) => ({ ...prevState, recoveryToggle: !prevState.recoveryToggle }));
  };

  const toggleVerify = () => {
    if (!state.setup) {
      if (state.renew || (!state.strict && state.setup)) {
        navigate("/manager/dashboard");
      } else {
        logoutUser();
      }
    } else {
      setState((prevState) => ({ ...prevState, setupShowVerify: !prevState.setupShowVerify }));
    }
  };

  const render = (
    <Box
      sx={{
        position: "relative",
        zIndex: "3",
        paddingRight: "15px",
        paddingLeft: "15px",
        marginRight: "auto",
        marginLeft: "auto",
        "@media (min-width: 768px)": {
          width: "750px",
        },
        "@media (min-width: 992px)": {
          width: "970px",
        },
        "@media (min-width: 1200px)": {
          width: "1170px",
        },
        "&:before,&:after": {
          display: "table",
          content: '" "',
        },
        "&:after": {
          clear: "both",
        },
      }}
    >
      <GridContainer sx={{ justifyContent: "center" }}>
        <GridItem md={6} sm={12} xs={12}>
          <Card
            sx={{
              borderRadius: "6px",
              boxShadow:
                "0 16px 24px 2px rgba(" +
                hexToRgb(blackColor) +
                ", 0.14), 0 6px 30px 5px rgba(" +
                hexToRgb(blackColor) +
                ", 0.12), 0 8px 10px -5px rgba(" +
                hexToRgb(blackColor) +
                ", 0.2)",
              marginBottom: "100px",
              padding: "40px 0px",
              marginTop: "15vh",
            }}
          >
            <img
              alt={"Logo"}
              src={logo}
              style={{
                width: "50%",
                margin: "0 25%",
              }}
            />

            <CardBody>
              {state.setup && !state.setupShowVerify ? (
                <div style={{ margin: "0 10px 10px 10px" }}>
                  <Link href={"https://knowledge.jamezz.com/knowledge/how-do-i-setup-2"}>Need help?</Link>
                  <InfoBlock
                    title={
                      <TranslationWrapper tDefault={"Download an Authenticator App"} tKey={"totp.download.app.title"} />
                    }
                  >
                    <TranslationWrapper tDefault={"Download and Install an"} tKey={"totp.download.app.text.part1"} />
                    &nbsp;
                    <a
                      href={"https://www.microsoft.com/nl-nl/account/authenticator"}
                      rel={"noopener noreferrer"}
                      target={"_blank"}
                    >
                      <TranslationWrapper tDefault={"Authenticator App"} tKey={"totp.download.app.link"} />
                    </a>
                    &nbsp;
                    <TranslationWrapper tDefault={"for your phone or tablet"} tKey={"totp.download.app.text.part2"} />
                  </InfoBlock>
                  <InfoBlock title={<TranslationWrapper tDefault={"Scan the QR Code"} tKey={"totp.scan.qr.title"} />}>
                    <p>
                      <TranslationWrapper
                        tDefault={
                          "Open the Authenticator App, tap the " + " and scan the QR code using your phone or tablet."
                        }
                        tKey={"totp.scan.qr.text"}
                      />
                    </p>

                    <div style={{ padding: "10px 0 20px 0" }}>
                      <img
                        alt={"QR Code"}
                        src={state.qrCode}
                        style={{
                          width: "50%",
                          margin: "0 25%",
                        }}
                      />
                    </div>

                    <p>
                      <TranslationWrapper tDefault={"Manual code"} tKey={"totp.scan.qr.manual"} />:
                    </p>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "10px",
                        color: "white",
                        background: "#495057bd",
                        margin: "0 15px 20px 15px",
                        fontWeight: "600",
                        borderRadius: "5px",
                        wordBreak: "break-all",
                      }}
                    >
                      {state.secret}
                    </div>

                    <p>
                      <strong>
                        <TranslationWrapper tDefault={"Note"} tKey={"totp.scan.note"} />:
                      </strong>
                      &nbsp;
                      <TranslationWrapper
                        tDefault={
                          "Closing this tab before entering your security code will require you to rescan your QR code"
                        }
                        tKey={"totp.scan.note.text"}
                      />
                    </p>

                    <div style={{ display: "flex", justifyContent: "end" }}>
                      <Button color={"primary"} onClick={toggleVerify}>
                        <ArrowForward />
                      </Button>
                    </div>
                  </InfoBlock>
                </div>
              ) : (
                ""
              )}

              {!state.setup || state.setupShowVerify ? (
                <form
                  onSubmit={handleSubmit}
                  ref={formRef}
                  style={{
                    padding: "0 20px",
                    position: "relative",
                  }}
                >
                  <InfoBlock
                    title={
                      !state.recoveryToggle ? (
                        <TranslationWrapper tDefault={"Verify OTP"} tKey={"totp.verify.title"} />
                      ) : (
                        <TranslationWrapper tDefault={"Recovery"} tKey={"totp.recovery.title"} />
                      )
                    }
                  >
                    <p style={{ padding: "0 0 10px 0" }}>
                      {!state.recoveryToggle ? (
                        <TranslationWrapper
                          tDefault={"Enter your one time password generated by your authenticator app"}
                          tKey={"totp.verify.text"}
                        />
                      ) : (
                        <TranslationWrapper tDefault={"Enter your back-up code"} tKey={"totp.recovery.text"} />
                      )}
                    </p>
                    <input name={"rd"} type={"hidden"} value={getParameterByName("rd")} />
                    {state.hasErrors ? (
                      <Danger>
                        {Object.keys(state.errors).map((errorKey) => {
                          return state.errors[errorKey].map((prop, key) => {
                            return (
                              <h5 key={key} style={{ textAlign: "center" }}>
                                {prop}
                              </h5>
                            );
                          });
                        })}
                      </Danger>
                    ) : null}
                    <div
                      style={{
                        display: "inline-block",
                        margin: "0px 0px 10px 15px",
                        borderBottom: "solid 1px",
                        color: "#696969",
                        fontSize: "15px",
                      }}
                    >
                      {state.email ?? ""}
                    </div>
                    <CustomInput
                      formControlProps={{
                        fullWidth: true,
                        style: {
                          margin: "0 12px",
                        },
                      }}
                      inputProps={{
                        name: "otp",
                        startAdornment: (
                          <InputAdornment position={"start"}>
                            <Lock />
                          </InputAdornment>
                        ),
                        placeholder: !state.recoveryToggle ? "OTP" : "Back-up code",
                        type: "text",
                        autoComplete: "off",
                      }}
                    />
                    {!state.recoveryToggle && !state.renew ? (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={state.trust}
                            inputProps={{
                              name: "trust",
                              value: state.trust,
                              onChange: handleCheckbox,
                            }}
                            tabIndex={-1}
                          />
                        }
                        label={
                          <span>
                            <TranslationWrapper tDefault={"Trust this device for 30 days"} tKey={"totp.verify.trust"} />
                          </span>
                        }
                        sx={{
                          margin: 0,
                        }}
                      />
                    ) : (
                      ""
                    )}
                    <div
                      style={{
                        marginTop: "15px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignText: "center",
                      }}
                    >
                      <Button onClick={toggleVerify}>
                        <ArrowBack />
                      </Button>
                      {state.loading ? (
                        <Button color={"primary"} disabled>
                          <CircularProgress
                            size={18}
                            style={{
                              marginRight: "8px",
                              color: "#fff",
                            }}
                          />
                        </Button>
                      ) : (
                        <Button color={"primary"} type={"submit"}>
                          <TranslationWrapper tDefault={"Authenticate"} tKey={"totp.verify.authenticate"} />
                        </Button>
                      )}
                    </div>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingTop: "15px",
                        marginTop: "10px",
                        borderTop: "solid 1px",
                        borderColor: "lightgrey",
                      }}
                    >
                      {!state.setup && !state.renew ? (
                        <span>
                          {state.recoveryToggle ? (
                            <span>
                              <TranslationWrapper tDefault={"To use OTP instead"} tKey={"totp.recovery.otp"} />
                              &nbsp;
                              <a href={"#0"} onClick={toggleRecovery}>
                                <TranslationWrapper tDefault={"click here"} tKey={"totp.click"} />
                              </a>
                              .
                            </span>
                          ) : (
                            <span>
                              <TranslationWrapper tDefault={"To use backup codes"} tKey={"totp.recovery.code"} />
                              &nbsp;
                              <a href={"#0"} onClick={toggleRecovery}>
                                <TranslationWrapper tDefault={"click here"} tKey={"totp.click"} />
                              </a>
                              .
                            </span>
                          )}
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </InfoBlock>
                </form>
              ) : null}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>

      {state.redirect ? <Navigate to={"/manager/"} /> : null}
    </Box>
  );

  return state.setup === null ? <Glas /> : render;
};

export default Setup2FA;
